module.exports = __webpack_public_path__ + "img/manajemen_partner.f670412f.svg";